import { render, staticRenderFns } from "./small-card.vue?vue&type=template&id=f42d1f48"
import script from "./small-card.vue?vue&type=script&lang=js"
export * from "./small-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports